/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { useMutation } from 'react-query';
import { model } from '@whizz/api-client';
import { Alert, Button, Loader } from '../../../../components';
import { useSearchParam } from 'react-use';
import JungleLayout from '../../../../layouts/JungleLayout';
import Whizzy from '../../../../assets/icon-default-whizzy.svg';

export default function ParentEmailConsent(this: any) {
  const { translate } = useI18n();
  const [ error, setError ] = useState<string | null>(null);
  const [ success, setSuccess ] = useState<string | null>(null);
  const consentParam = useSearchParam('consentHash');

  const acceptConsentMutation = useMutation({
    mutationFn: (consentHash: string) => model.Guardians.acceptConsent(consentHash),
    onSuccess: () => setSuccess(translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS')),
    onError: () => setError(translate('pages.PARENT_EMAIL_PROCESS.CONSENT.ERROR')),
  });

  useEffect(() => {
    if (consentParam) {
      acceptConsentMutation.mutate(consentParam);
    } else {
      setError(translate('pages.PARENT_EMAIL_PROCESS.CONSENT.NO_HASH'));
    }
  }, [ consentParam ]);

  return (
    <JungleLayout>

      {consentParam && acceptConsentMutation.isLoading && (
        <Loader>
        </Loader>
      )}

      {null !== success && (
        <>
          <h1 className={'mb-4 text-2xl sm:text-4xl font-bold text-header text-center'}>
            {translate('pages.PARENT_EMAIL_PROCESS.HEADER')}
          </h1>
          <hr />
          <div className={'flex justify-end px-10'}>
            <img src={Whizzy} className={'w-16 md:w-20 animate-wiggle sm:-mb-10'} />
          </div>
          <div className={'space-y-6'}>
            <p>{translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS.line1')}</p>
            <p className='font-bold'>{translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS.line2')}</p>
            <p>{translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS.line3')}</p>
            <hr />
            <div>
              <p>{translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS.line4')}</p>
              <a href={`mailto:${translate('global.SUPPORT_EMAIL')}}`} className={'underline hover:no-underline pt-4'}>{translate('global.SUPPORT_EMAIL')}</a>
            </div>
            <div className={'flex justify-center'}>
              <a href={translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS.URL')}>
                <Button
                  isOutline
                  color={'positive'}
                >
                  {translate('pages.PARENT_EMAIL_PROCESS.CONSENT.SUCCESS.FIND_OUT_MORE')}
                </Button>
              </a>
            </div>
          </div>
        </>
      )}

      {null !== error && (
        <Alert show type={'error'} className={'mb-5'}>
          {error}
        </Alert>
      )}

    </JungleLayout>
  );
}
